import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

const AddEstudios = () => {
  const [Estudios, setEstudios] = useState([]);
  const [Nombre, setNombre] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});
  const [estudioEditando, setEstudioEditando] = useState(null);
 const [filtroEstado, setFiltroEstado] = useState("activas");
  useEffect(() => {
    getEstudios();
  }, []);

  const editFields = [
    { name: "Nombre", label: "Nombre del estudio", type: "text", required: true },
    { name: "Descripcion", label: "Descripción", type: "text", required: false }
  ];

  const getEstudios = async () => {
    const response = await api.get(`/getEstudios`);
    setEstudios(response.data);
  };

  const filtrarEstudios = () => {
  if (filtroEstado === "activas") {
    return Estudios.filter((e) => e.estado === 1);
  }
  if (filtroEstado === "inactivas") {
    return Estudios.filter((e) => e.estado === 0);
  }
  return Estudios;
};


  const createEstudio = async (e) => {
    e.preventDefault();


 


    const existe = Estudios.some(
      (e) => normalizar(e.Nombre) === normalizar(Nombre)
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe un estudio con ese nombre.",
        confirmButtonColor: "#3085d6"
      });
      return;
    }

    try {
      await api.post(`/createEstudio`, {
        Nombre,
        Descripcion,
      });
      getEstudios();
      setNombre("");
      setDescripcion("");
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "El estudio fue guardado exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al guardar el estudio.",
      });
    }
  };

  const handleEditEstudio = async (values) => {
    try {
      await api.patch(
        `/estudios/updateEstudio/${values.IdEstudio}`,
        { Nombre: values.Nombre, Descripcion: values.Descripcion }
      );
      Swal.fire({
        icon: "success",
        title: "Estudio actualizado",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al actualizar el estudio.",
      });
    }
    setEstudioEditando(null);
    getEstudios();
  };

 const cambiarEstado = async (IdEstudio) => {
  try {
    const estudio = Estudios.find(e => e.IdEstudio === IdEstudio);
    const nuevoEstado = estudio.estado === 1 ? 0 : 1;

    await api.patch(`/estudios/cambiarEstadoEstudio/${IdEstudio}`);
    getEstudios();

    Swal.fire({
      icon: "success",
      title: nuevoEstado === 1 ? "Estudio activado" : "Estudio desactivado",
      text: `El estudio fue ${nuevoEstado === 1 ? "activado" : "desactivado"} correctamente.`,
      timer: 1500,
      showConfirmButton: false,
    });
  } catch (error) {
if (
  error.response &&
  error.response.status === 409 &&
  error.response.data.code === "ESTUDIO_ASOCIADO"
) {
  const patologias = error.response.data.patologias || [];
  const detalle = patologias.length > 0 
    ? `<br><strong>Patologías asociadas:</strong> ${patologias.join(", ")}`
    : "";

  Swal.fire({
    icon: "warning",
    title: "No permitido",
    html: `${error.response.data.mensaje}${detalle}`,
  });

    } else {
      console.error("Error al cambiar estado:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrió un error al cambiar el estado del estudio.",
      });
    }
  }
};

  const columnas = [
    {
      name: 'Nombre',
      selector: row => row.Nombre,
      sortable: true
    },
    {
      name: 'Descripción',
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion({ ...mostrarDescripcion, [row.IdEstudio]: !mostrarDescripcion[row.IdEstudio] });
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > 40;

        const estiloCelda = {
          display: 'flex',
          alignItems: 'center',
          width: '400vw',
          maxHeight: mostrarDescripcion[row.IdEstudio] ? 'none' : '40vh',
          overflow: mostrarDescripcion[row.IdEstudio] ? 'visible' : 'hidden',
        };

        const estiloContenido = {
          flex: 1,
          maxHeight: '45vh',
          textOverflow: mostrarDescripcion[row.IdEstudio] ? 'clip' : 'ellipsis',
          whiteSpace: mostrarDescripcion[row.IdEstudio] ? 'normal' : 'nowrap',
        };

        return (
          <div style={estiloCelda}>
            <div style={estiloContenido}>
              {!mostrarDescripcion[row.IdEstudio] ? (descripcion.length > 70 ? descripcion.substring(0, 70) + '...' : descripcion) : descripcion}
            </div>
            {mostrarBoton && (
              <button className="btn" onClick={(e) => {
                toggleDescripcion();
                e.preventDefault();
              }}>
                {mostrarDescripcion[row.IdEstudio] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: '40vw',
    },
    {
      cell: (row) => (
        <button
          className="button is-small is-info mr-2 icon-pencil"
          title="Editar"
          onClick={() => setEstudioEditando(row)}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      button: true
    },
    {
      name: "Activo",
      cell: (Estudio) =>
        Estudio.estado === 1 ? (
          <FontAwesomeIcon
            icon={faSquarePlus}
            style={{ color: "#37ff00", cursor: "pointer" }}
            size="2xl"
            onClick={() => cambiarEstado(Estudio.IdEstudio)}
          />
        ) : (
          <FontAwesomeIcon
            icon={faSquareMinus}
            style={{ color: "#ff0000", cursor: "pointer" }}
            size="2xl"
            onClick={() => cambiarEstado(Estudio.IdEstudio)}
          />
        ),
      ignoreRowClick: true,
      AllowOverflow: true,
      button: true,
      compact: true
    }
  ];


  const paginationOptionsES = {
  rowsPerPageText: 'Filas por página',
  rangeSeparatorText: 'de',
  selectAllRowsItem: true,
  selectAllRowsItemText: 'Todos',
};
  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Ingresa el Estudio</strong>
        </div>
        <form onSubmit={createEstudio}>
          <div className="field">
            <label className="label required">Nombre del estudio</label>
            <div className="control">
              <input
                type="name"
                className="input"
                value={Nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Nombre"
                required
              />
            </div>

            <label className="label">Descripcion del estudio</label>
            <div className="control">
              <input
                type="text"
                className="input"
                value={Descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                placeholder="Descripcion"
              />
            </div>
          </div>

          <div className="field">
            <div>
              <button type="submit" className="button is-success">Guardar</button>
            </div>
          </div>
        </form>
        <br />

        <div style={{ width: 'auto', left: '20vw', position: 'absolute', border: '1px solid gray', borderRadius: '8px' }}>
        
        <div style={{ display: 'flex', gap: '10px', marginBottom: '1rem' }}>
  {["todas", "activas", "inactivas"].map((estado) => (
    <button
      key={estado}
      onClick={() => setFiltroEstado(estado)}
      type="button"
      style={{
        padding: "6px 16px",
        border: "none",
        borderRadius: "20px",
        backgroundColor: filtroEstado === estado ? "#d1f5d3" : "#f0f2f5",
        color: filtroEstado === estado ? "#075e54" : "#333",
        fontWeight: filtroEstado === estado ? "bold" : "normal",
        boxShadow:
          filtroEstado === estado
            ? "inset 0 0 0 1px #1ebea5"
            : "inset 0 0 0 1px #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        fontSize: "0.9rem",
      }}
    >
      {estado.charAt(0).toUpperCase() + estado.slice(1)}
    </button>
  ))}
</div>
        
        
        
          <DataTable
            pagination
            paginationComponentOptions={paginationOptionsES}
            columns={columnas}
            data={filtrarEstudios()}
            dense={false}
          />
        </div>

        {estudioEditando && (
          <EditModal
            fields={editFields}
            initialValues={estudioEditando}
            onSubmit={handleEditEstudio}
            onClose={() => setEstudioEditando(null)}
            title="Editar Estudio"
          />
        )}
      </div>
    </div>
  );
};

export default AddEstudios;